import React from 'react';
import { type OverseaFeatureItem } from '@/apiSdk/api.type';
import ClientHeader from './ClientHeader';
import ServerHeader, { type OverseaOfficialHeaderAppearance } from './ServerHeader';

interface HeaderProps {
  isSSR?: boolean;
  showAlert?: boolean;
  appearance?: OverseaOfficialHeaderAppearance;
  menus: Record<'product' | 'blog', OverseaFeatureItem[]>;
}

/**
 * Header 组件入口
 * 根据环境返回服务端或客户端组件
 */
export default function Header({
  showAlert, isSSR = false, menus, appearance,
}: HeaderProps) {
  // 服务端渲染时返回静态组件
  if (isSSR) {
    return <ServerHeader showAlert={showAlert} menus={menus} appearance={appearance} />;
  }

  // 客户端渲染时返回动态组件
  return <ClientHeader showAlert={showAlert} menus={menus} appearance={appearance} />;
}

export { ServerHeader, ClientHeader };
export type { OverseaOfficialHeaderAppearance };
